import React from "react";
import ThemeTopLayout from "gatsby-theme-material-ui-top-layout/src/components/top-layout";
import { Box, createTheme, responsiveFontSizes } from "@mui/material";
import { blue, green, grey } from "@mui/material/colors";
import { Footer } from "../../components/Footer";

// === THEME DEFINITIONS ===
const themeB = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "light",
      primary: { main: green[600] },
      background: { default: grey[200] },
    },
    typography: { fontFamily: "Lora" },
    shape: { borderRadius: 10 },
  })
);

const themeC = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "light",
      primary: { main: blue[700] },
      background: { default: grey[200] },
    },
    typography: { fontFamily: "Ubuntu Mono" },
    shape: { borderRadius: 5 },
  })
);

const themeD = responsiveFontSizes(
  createTheme({
    palette: {
      mode: "dark",
      primary: { main: "#f2e959" },
      secondary: { main: "#bd362c" },
    },
    typography: { fontFamily: "Ubuntu Mono" },
    shape: { borderRadius: 5 },
  })
);

const themeE = responsiveFontSizes(
  createTheme({
    palette: {
      primary: { main: "#FFFF" },
    },
    typography: { fontFamily: "Source Sans 3" },
    shape: { borderRadius: 5 },
  })
);

// === DOMAIN → THEME MAPPING ===
const domainThemeMap = {
  "http://localhost:8000": "default", // use passed-in `theme`
  "https://vestimak.mk": "default",

  "http://localhost:8001": "b",
  "https://vestimk.mk": "b",

  "http://localhost:8002": "c",
  "https://utre.mk": "c",

  "http://localhost:8003": "d",
  "https://24mk.mk": "d",

  "http://localhost:8004": "e",
  "https://mk24.mk": "e",
};

const themes = {
  b: themeB,
  c: themeC,
  d: themeD,
  e: themeE,
};

export default function TopLayout({ children, theme: defaultTheme }) {
  const [themeKey, setThemeKey] = React.useState(null);

  React.useEffect(() => {
    const origin = window?.location.origin;
    const key = domainThemeMap[origin] || null;
    setThemeKey(key);
  }, []);

  if (!themeKey) return null;

  const selectedTheme =
    themeKey === "default" ? defaultTheme : themes[themeKey];

  return (
    <ThemeTopLayout theme={selectedTheme}>
      {children}
      {themeKey === "default" && <Footer />}
    </ThemeTopLayout>
  );
}
